<template>
    <el-card>
        <el-row>
            <el-form ref="form" :model="form" label-width="150px" v-loading="loading"
                :element-loading-text="loadingText">
                <el-form-item label="会员信息" prop="customer">
                    <el-select v-model="customer" placeholder="请选择会员"
                    filterable value-key="id"
                    remote :remote-method="remoteCustomerMethod" :loading="customer_loading">
                        <el-option v-for="c in customers" :key="c.id"
                            :label="c.name" :value="c.id"></el-option>
                    </el-select>&nbsp;&nbsp;
                    <el-button type="primary" @click="viewFormerYearsData">查看该会员文书</el-button>
                </el-form-item>
                
            </el-form>
        </el-row>
        <el-row>
            <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" fit
                highlight-current-row class="w-100">

                <el-table-column align="left" label="船名">
                    <template slot-scope="scope">
                        <span>{{ scope.row.ship_name }}</span>
                    </template>
                </el-table-column>

                <el-table-column align="left" label="船舶类型">
                    <template slot-scope="scope">
                        <span>{{ scope.row.ship_type }}</span>
                    </template>
                </el-table-column>

                <el-table-column align="left" label="险种">
                    <template slot-scope="scope">
                        <span>{{ scope.row.insurance_type }}</span>
                    </template>
                </el-table-column>

                <el-table-column align="left" label="保险公司">
                    <template slot-scope="scope">
                        <span>{{ scope.row.insurance_company }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="投保年份">
                    <template slot-scope="scope">
                        <span>{{ scope.row.year }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="保险期间">
                    <template slot-scope="scope">
                        <span>{{ scope.row.insurance_period }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="保险金额">
                    <template slot-scope="scope">
                        <span>{{ scope.row.insured_premium }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="主险费率(%)">
                    <template slot-scope="scope">
                        <span>{{ scope.row.insured_rate }}</span>
                    </template>
                </el-table-column>

                <el-table-column align="left" label="总保费">
                    <template slot-scope="scope">
                        <span>{{ scope.row.total_insured_premium }}</span>
                    </template>
                </el-table-column>

            </el-table>
        </el-row>
    </el-card>
</template>
  
<script>


import { fetchShipNameList } from '@/api/ship'
import { rateReportList } from '@/api/report'
import { fetchCustomerList} from '@/api/customer'


export default {
    name: 'finace-report',
    data() {
        return {
            form: {
                append_date: 1,
                join_date: '',
                activity: '',
                department: '',
                big_begin_date: '',
                big_end_date: '',
                insured: '',
                customer: '',
                ship: '',
                dues: 0,
                pay_gross_ton: 0,
                small_begin_date: '',
                small_end_date: '',
                balance: 0,
                remark: { "content": '' },
                contact: '',
                contact_mobile: ''
            },
            ships: [],
            customer_loading: false,
            loadingText: '正在加载数据，请稍等...',
            loading: false,
            customer:null,
            list: []

        }
    },
    methods: {
        remoteCustomerMethod(query) {
        if (query !== '') {
          this.customer_loading = true
          setTimeout(() => {
            fetchCustomerList({'search': query}).then(res => {
              this.customers = res
              this.customer_loading = false
            }).catch(err => {
              this.customer_loading = false
              this.$error_message(err)
            })
          }, 200);
        } else {
          this.customers = [];
        }
      },
        handleShipInfo(item) {
        },
        viewFormerYearsData() {
            rateReportList({ 'ship': this.form.ship }).then(res => {
                this.list = res

            }).catch(err => {

            })
            console.log(this.form.ship)

        },
        remoteShipMethod(query) {
            if (query !== '') {
                this.ship_loading = true
                setTimeout(() => {
                    fetchShipNameList({ 'search': query }).then(res => {
                        this.ships = res
                        this.ship_loading = false
                    }).catch(err => {
                        this.ship_loading = false
                        this.$error_message(err)
                    })
                }, 200);
            } else {
                this.ships = [];
            }
        },


    },
    created() {

    }
}
</script>